import type { FormConfig } from '../types';
import coverSheet from '../pages/tableau/coverSheet';

const formConfig: FormConfig = {
  live: false,
  id: 'tableau',
  formName: 'Tableau Placeholder Form',
  title: 'Tableau Placeholder Form',
  subTitle: 'Summary page',
  showSections: true,
  approval: 'optional',
  sections: [
    {
      title: 'Main Section',
      slug: 'main-section',
      subsections: [
        {
          title: 'Cover Sheet',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },
  ],
};

export default formConfig;
